import axiosFlow from '@/services/axios/axiosFlow'

export default class RelatorioService {
  static async getRelatorioFila(filaId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (filaId) {
      params.append('FilaId', filaId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`relatorio/filas?${params}`).then(res => res.data.data)
  }

  static async getRelatorioTicketFormulariosRespostas(filaId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (filaId) {
      params.append('FilaId', filaId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`relatorio/ticket-formularios-respostas?${params}`).then(res => res.data.data)
  }

  static async getRelatorioEquipe(equipeId, agenteSelecionadoId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (equipeId) {
      params.append('EquipeId', equipeId)
    }
    if (agenteSelecionadoId) {
      params.append('AgenteId', agenteSelecionadoId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`relatorio/equipes?${params}`).then(res => res.data.data)
  }

  static buildRelatorioSlaParams({
    filaIds, canalId, tipoSolicitacaoId, dataInicio, dataFim,
  }) {
    const params = new URLSearchParams()

    if (filaIds?.length) filaIds.forEach(id => params.append('FilaIdList', id))
    if (canalId) params.append('CanalId', canalId)
    if (tipoSolicitacaoId) params.append('TipoSolicitacaoId', tipoSolicitacaoId)
    if (dataInicio) params.append('Inicio', dataInicio)
    if (dataFim) params.append('Fim', dataFim)

    return params
  }

  static async getRelatorioSla({
    filaIds, canalId, tipoSolicitacaoId, dataInicio, dataFim,
  }) {
    const params = RelatorioService.buildRelatorioSlaParams({
      filaIds, canalId, tipoSolicitacaoId, dataInicio, dataFim,
    })

    return axiosFlow.get(`relatorio/slas?${params}`).then(res => res.data.data)
  }

  static async getRelatorioSlaDescumprimentos({
    filaIds, canalId, tipoSolicitacaoId, dataInicio, dataFim,
  }) {
    const params = RelatorioService.buildRelatorioSlaParams({
      filaIds, canalId, tipoSolicitacaoId, dataInicio, dataFim,
    })

    return axiosFlow.get(`relatorio/slas/descumprimentos?${params}`).then(res => res.data.data)
  }

  static async getRelatorioTotalAtendimentosChatbot(chatBotId, chatBotArvoreId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (chatBotId) {
      params.append('ChatBotId', chatBotId)
    }
    if (chatBotArvoreId) {
      params.append('ChatBotArvoreId', chatBotArvoreId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`relatorio/total-atendimentos-chatbot?${params}`).then(res => res.data.data.result[0])
  }

  static async getRelatorioChatBotArvore(chatBotId, chatBotArvoreId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (chatBotId) {
      params.append('ChatBotId', chatBotId)
    }
    if (chatBotArvoreId) {
      params.append('ChatBotArvoreId', chatBotArvoreId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`relatorio/chatbot/arvores?${params}`).then(res => res.data.data)
  }

  static async getRelatorioChatBotArvorePesquisaSatisfacao(chatBotId, chatBotArvoreId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (chatBotId) {
      params.append('ChatBotId', chatBotId)
    }
    if (chatBotArvoreId) {
      params.append('ChatBotArvoreId', chatBotArvoreId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`relatorio/chatbot/arvores/pesquisa-satisfacao?${params}`).then(res => res.data.data)
  }

  static async getRelatorioEnvioMassa({ agendamentoId, logStatusIds, dataInicio, dataFim }) {
    const params = new URLSearchParams()

    if (agendamentoId) params.append('AgendamentoId', agendamentoId)
    if (dataInicio) params.append('DataInicio', dataInicio)
    if (dataFim) params.append('DataFim', dataFim)
    if (logStatusIds?.length) logStatusIds.forEach(id => params.append('LogStatusIds', id))

    return axiosFlow.get(`relatorio/envio-massa?${params}`).then(res => res.data.data)
  }

  static async getRelatorioEnvioMassaDetalhes(agendamentoId, logStatusIds) {
    const params = new URLSearchParams()

    if (logStatusIds?.length) logStatusIds.forEach(id => params.append('LogStatusIds', id))

    return axiosFlow.get(`relatorio/envio-massa/${agendamentoId}/detalhes?${params}`).then(res => res.data.data)
  }

  static async getInteracoesClienteChatbotPagina(chatBotId, dataInicio, dataFim, pagina = 1, tamanhoPagina = 200) {
    const params = new URLSearchParams()

    if (chatBotId) params.append('ChatBotId', chatBotId)
    if (dataInicio) params.append('Inicio', dataInicio)
    if (dataFim) params.append('Fim', dataFim)
    params.append('Pagina', pagina)
    params.append('TamanhoPagina', tamanhoPagina)

    return axiosFlow.get(`relatorio/chatbot/interacoes-clientes?${params}`).then(res => res.data.data)
  }

  // Busca todas as páginas em sequência, pra não truncar clientes silenciosamente quando o
  // total ultrapassa o tamanho de uma página (o relatório é de um período fechado, não uma
  // listagem paginada de verdade — precisa vir completo pros KPIs/chips e pro export Excel
  // baterem com o total real). O backend agora devolve { totalClientes, clientes }, e usamos
  // totalClientes (não o tamanho da última página) pra saber quando parar.
  static async getInteracoesClienteChatbot(chatBotId, dataInicio, dataFim, tamanhoPagina = 200) {
    const todosOsClientes = []
    let pagina = 1
    let totalClientes = 0
    let paginaAtual

    do {
      // eslint-disable-next-line no-await-in-loop
      paginaAtual = await RelatorioService.getInteracoesClienteChatbotPagina(chatBotId, dataInicio, dataFim, pagina, tamanhoPagina)
      todosOsClientes.push(...paginaAtual.clientes)
      totalClientes = paginaAtual.totalClientes
      pagina += 1
    } while (todosOsClientes.length < totalClientes)

    return { clientes: todosOsClientes, totalClientes }
  }
}
